import { Component, OnInit,Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import { UntypedFormControl, UntypedFormGroup, Validators,UntypedFormBuilder } from '@angular/forms';
import { ConveniosService } from '../../../services/convenios.service';
import { EmpresaService } from '../../../services/empresa.service';
import { CurrenyService } from 'app/modules/common/services/curreny.service';
import {ConvenioModel} from '../models/ConvenioModel'
@Component({
    selector: 'app-convenios-popup',
    templateUrl: './convenios-popup.component.html',
    styleUrls: ['./convenios-popup.component.scss'],
    standalone: false
})

export class ConveniosPopupComponent implements OnInit {
  dataSourceConvenio;
  dataSourceNullAttributo;
  EmpresaId;
  salaryButo;
  public convenioList: any[]  
  public addConvenioAtributoForm: UntypedFormGroup;
  ConvenioModel: ConvenioModel;
  constructor
  (
    public _dialogRef: MatDialogRef<ConveniosPopupComponent>,
    private _conveniosService: ConveniosService,
    private _empresaService: EmpresaService,
    private _sharedService: SharedService,
    private _formBuilder: UntypedFormBuilder,
    private _dialogRef1: MatDialogRef<ConveniosPopupComponent>,
    private _currencyService: CurrenyService,
    @Inject(MAT_DIALOG_DATA) public data: any

  ) { 
    this.ConvenioModel = new ConvenioModel();
  }
  ngOnInit(): void {
    this.EmpresaId=this.data.empresaid;
    this.getConvinioList();
    if(this.data.isinsert)
    {      
      this.getNullAttributoEmpresa(this.EmpresaId);
      //Insert Convenios Form Builder
        this.addConvenioAtributoForm =new UntypedFormGroup( {
        id: new UntypedFormControl(0),
        empresaId: new UntypedFormControl(''),
        tipoAtributo: new UntypedFormControl( '' ,Validators.required),
        atributo: new UntypedFormControl( '' ,Validators.required),
        convenioId: new UntypedFormControl( '',Validators.required ),
        salarioBruto: new UntypedFormControl('',Validators.required ),
      } );
    }
    else
    {
      this.getNullAttributoEmpresaWithSelected(this.data.empresaid,this.data.element.tipoAtributo)
      //Update Convenios Form Builder
       this.addConvenioAtributoForm = this._formBuilder.group({
        id: new UntypedFormControl(this.data.element.id),
        empresaId: new UntypedFormControl(this.data.empresaid),
        tipoAtributo: new UntypedFormControl( this.data.element.tipoAtributo ,Validators.required),
        atributo: new UntypedFormControl( this.data.element.atributo,Validators.required),
        convenioId: new UntypedFormControl( this.data.element.convenioId,Validators.required ),
        salarioBruto: new UntypedFormControl( this.data.element.salarioBruto,Validators.required ),
    });
    }
       
  }

  cancel() {
    this._dialogRef.close();
  }

  saveConvenioAtributo(){
    this.addConvenioAtributoForm.patchValue({
      empresaId:this.EmpresaId
    });
    this.addConvenioAtributoForm.markAllAsTouched();
    this.addConvenioAtributoForm.updateValueAndValidity();
    if (this.addConvenioAtributoForm.valid) 
    {
      if(this.addConvenioAtributoForm.get('id').value==0)
      {
        this.AddConvenioAtributo();
      }
      else
      {
        this.UpdateConvenioAtributo();
      }
    }else
    {
      console.log( this.addConvenioAtributoForm.value );
    }
  }

 
  //Add ConvenioAtributo
  private AddConvenioAtributo() {    
    var model = new ConvenioModel()
    Object.assign(model,this.addConvenioAtributoForm.value)
    model.salarioBruto = this._currencyService.replaceSpanishFormat(this.addConvenioAtributoForm.get('salarioBruto').value.toString());
    
    this._conveniosService.AddConvenioAtributo(model)
      .subscribe(res => {
        if (res.code === 0) {
          this.getConvinioList();
          this.getNullAttributoEmpresa(this.EmpresaId);
          this.cancel();
        } else {
        }
      }, err => {
        console.log(err)
        this._sharedService.ShowSnackBar('API solicitud fallida', 'Okay', 2000);      
      });
  }

  //Update ConvenioAtributo
  private UpdateConvenioAtributo() {
    var model = new ConvenioModel()
    Object.assign(model,this.addConvenioAtributoForm.value)
    model.salarioBruto = this._currencyService.replaceSpanishFormat(this.addConvenioAtributoForm.get('salarioBruto').value.toString());

    this._conveniosService.UpdateConvenioAtributo(model)
      .subscribe(res => {
        if (res.code === 0 ) {
          this.getConvinioList();
          this.getNullAttributoEmpresa(this.EmpresaId);
          //this._sharedService.ShowSnackBar('Convenio atributo actualizado exitosamente', 'Okay', 2000);
          this.cancel();
        } else {
          //this._sharedService.ShowSnackBar('Convenio atributo actualizacion fallida', 'Okay', 2000);
        }
      }, err => {
        console.log(err)
        this._sharedService.ShowSnackBar('API solicitud fallida', 'Okay', 2000);      
      });
  }

  public getConvinioList() {
    this._empresaService.GetConvenioList()      
      .subscribe(res => {
        this.convenioList = this.groupBy(res.result,'grupo')         
        this.convenioList = Object.keys(this.convenioList).map((key) => {
          var a = {
            name: key,
            data: this.convenioList[key]
          }
          return a;
        });           
      });
  }
  private groupBy = (items, key) => items.reduce(
    (result, item) => ({
      ...result,
      [item[key]]: [
        ...(result[item[key]] || []),
        item,
      ],
    }), 
    {},
  )
  private getNullAttributoEmpresa(EmpresaId: any) {
    this._conveniosService.GetNullAttributoEmpresa(EmpresaId)
      .subscribe(res => {
        this.dataSourceNullAttributo = res.result;
      });
  }
  private getNullAttributoEmpresaWithSelected(EmpresaId: any,selected: any) {
    this._conveniosService.GetNullAttributoEmpresaWithSelected(EmpresaId,selected)
      .subscribe(res => {
        this.dataSourceNullAttributo = res.result;
      });
  }

}
